import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FaViewState } from "./types";

const initialState: FaViewState = {
  viewAsProvider: false,
};

export const faViewSlice = createSlice({
  name: "faView",
  initialState,
  reducers: {
    setViewAsProvider: (state, action: PayloadAction<boolean>) => {
      state.viewAsProvider = action.payload;
    },
  },
});

export const { setViewAsProvider } = faViewSlice.actions;

export default faViewSlice.reducer;
